'use client'

import { useContext } from 'react'
import { Cell } from '@vinted/web-ui'

import { PluginsContext, PluginName } from '@marketplace-web/item-page/item-page-data'
import { ItemPageReportButtonPlugin } from '@marketplace-web/report-button/report-button-feature'
import { ItemPageReportButtonPluginModel } from '@marketplace-web/report-button/report-button-data'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { ItemPageGalleryPluginModel } from '../../plugins/Gallery/types'
import ItemPageGalleryPlugin from '../../plugins/Gallery/ItemPageGalleryPlugin'
import Plugin from '../../plugins/Plugin'
import ItemPageGalleryPluginNew from '../../plugins/Gallery/NewGallery/ItemPageGalleryPluginNew'
import GalleryReworkWrapper from '../../plugins/Gallery/GalleryReworkWrapper'

type Props = {
  galleryPluginModel: ItemPageGalleryPluginModel | undefined
  reportButtonPluginModel: ItemPageReportButtonPluginModel | undefined
}

const ContentSection = ({ galleryPluginModel, reportButtonPluginModel }: Props) => {
  const galleryReworkTest = useAbTest('web_item_page_gallery_rework')
  const { plugins: serverSidePlugins } = useContext(PluginsContext)

  const galleryReworkEnabled = galleryReworkTest?.variant === 'on'

  return (
    <>
      <Plugin data={serverSidePlugins?.find(plugin => plugin.name === PluginName.Alert)} />
      <GalleryReworkWrapper>
        {!galleryReworkEnabled && galleryPluginModel && (
          <ItemPageGalleryPlugin data={galleryPluginModel} />
        )}
        {galleryReworkEnabled && galleryPluginModel && (
          <ItemPageGalleryPluginNew data={galleryPluginModel} />
        )}
      </GalleryReworkWrapper>
      {!galleryReworkEnabled && (
        <Cell
          theme="transparent"
          styling={Cell.Styling.Tight}
          body={
            <Plugin
              data={serverSidePlugins?.find(plugin => plugin.name === PluginName.Breadcrumbs)}
            />
          }
          suffix={<ItemPageReportButtonPlugin data={reportButtonPluginModel} />}
        />
      )}
    </>
  )
}

export default ContentSection
